<template>
  <div>
  <vx-card :style="'position:relative; cursor: pointer; background-size: cover; background-repeat: no-repeat; color:black; background: linear-gradient(118deg, #efefef, rgb(20 20 20 / 70%)), \'' + onboarding.firstImage + '\';'"
           :title="onboarding.name"
           title-color="#000"
           content-color="#000"
           @CardClick="OpenOnboarding(onboarding.id)"
           :class="'card-tall ' + (isOnboardingCompleted(onboarding) ? 'border-success' : '')">
    <p>
      {{ onboarding.description ? onboarding.description : 'This onboarding has no description yet.' }}
    </p>
    <img v-if="onboarding.firstImage && onboarding.firstImage.length > 0" :src="onboarding.firstImage" style="width:100%;" />
    <div slot="footer">
      <vs-row vs-justify="flex-end">
        <FeatherIcon v-if="isOnboardingCompleted(onboarding)" style="color:green" icon="CheckCircleIcon"></FeatherIcon>
      </vs-row>
    </div>
  </vx-card>
  </div>
</template>
<script>
  import FeatherIcon from "@/components/FeatherIcon.vue";

export default {
  data() {
    return {
      
    };
  },
  methods: {
    isOnboardingCompleted(onboarding) {
      return onboarding.currentUserStats != null && onboarding.currentUserStats == 'COMPLETED';
    },
    OpenOnboarding(id) {
      window.location.href = '/pages/pdf-view?oid=' + id;
    },
  },
  mounted() {
    
  },
    props: ["onboarding"],
    components: {
      FeatherIcon,
    }
};
</script>
<style>
  .card-tall.border-success {
    border: 1px solid rgb(var(--vs-primary));
  }

  .card-tall {
    max-height: 240px;
    height: 240px;
    min-height: 240px;
  }

    .card-tall .vx-card__title {
      max-height: 1.5em;
      overflow: hidden;
      height: 1.5em;
    }

      .card-tall .vx-card__title h4 {
        font-weight: 900;
      }

    .card-tall .vx-card__body {
      margin-bottom: 5px;
      overflow: hidden;
      max-height: 150px;
      min-height: 150px;
    }

    .card-tall.vx-card {
      /*border: 1px solid var(--primary);*/
      cursor: pointer;
    }

    .card-tall .vx-card__body img {
      margin-top: 10px;
      opacity: 0.4;
      filter: grayscale(1);
    }

    /*.card-tall:hover {
  transform: scale(1.02);
  z-index: 999999;
  filter: grayscale(0);
}*/

    .card-tall:hover img {
      filter: grayscale(0);
      opacity: 1;
    }

  /*.card-tall .vx-card:hover h4 {
  color: var(--primary) !important;
}*/
</style>
